
/* injects from baggage-loader */

import moment from "moment";
import { P1XP2MarketTypes } from "../../sport/sportData";
import Config from "../../../config/main";

export const getSwarmSubscriptionRequestGameListStandart = (gameType, sportAlias, regionId, competitionId, timeFilter) => {
    let req = {
        "source": "betting",
        "what": {
            "sport": [["name", "alias"]],
            "region": [["name", "id", "alias", "order"]],
            "competition": ["name", "id", "order"],
            "game": [["id", "team1_name", "team2_name", "order", "start_ts", "markets_count", "is_blocked", "exclude_ids", "team1_reg_name", "team2_reg_name", "info", "is_stat_available", "team1_id", "team2_id", "sportcast_id"]],
            "market": ["name", "type", "id", "express_id", "base", "display_key", "home_score", "away_score"],
            "event": ["name", "type", "id", "price", "order"]
        },
        "where": {
            "sport": {
                "type": { "@in": [0, 2, 5] }
            },
            "game": {"@or": [
                {"type": {"@in": [0, 2]}},
                {"visible_in_prematch": 1}]
            },
            "market": { "type": {"@in": P1XP2MarketTypes} },
            "event": { "type": { "@in": ["P1", "X", "P2"] }}
        }
    };
    if (regionId && regionId !== "all") {
        if (regionId.constructor === Array && regionId.length > 1) {
            req.where.region = {id: {"@in": +regionId}};
        } else {
            req.where.region = {id: regionId.constructor === Array ? regionId[0] : +regionId};
        }
    }
    if (!["all", "betBuilder"].includes(sportAlias)) {
        req.where.sport = {
            ...req.where.sport,
            "alias": sportAlias
        };
    }
    if (competitionId) {
        req.where.competition = {id: parseInt(competitionId, 10)};
    }
    if (gameType === "live") {
        req.where.game = {type: 1};
    }

    if (gameType === "topGames") {
        req.where.game = {
            "type": { "@in": [0, 2] },
            "promoted": true
        };
    }

    if (gameType === "today") {
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": {"@in": [0, 2]}
                }
            ]
        };
    }
    if (timeFilter === 999 && Config.enableTodayButtonOnSport) {
        req.where.game = {
            "@or": [{"type": {"@in": [0, 2]}}, {"visible_in_prematch": 1}]
        };
    }
    if (timeFilter === 0 && Config.enableTodayButtonOnSport) {
        let oneDayDate = moment().unix();
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': oneDayDate,
                        '@lte': oneDayDate + 86400
                    },
                    "type": {"@in": [0, 2]}
                }
            ]
        };
    }
    if (timeFilter) {
        req.where.game.start_ts = {
            '@now': {
                '@gte': Config.enableDayFormatInPrematchLeftMenu ? moment().startOf("day").unix() + (timeFilter * 2) : 0,
                '@lt': Config.enableDayFormatInPrematchLeftMenu ? moment().endOf("day").unix() + timeFilter : timeFilter * 3600
            }
        };
    }
    return req;
};